import { Button, Tooltip } from '@orbita-ui/core';
import { TableComponentParams } from '../../../../shared/table/hoc/withPagination';
import { Table } from '../../../../shared/table';
import { Tarjeta } from '../../models/Tarjeta';
import { TablePlaceholder } from 'shared/placeholders';
import { useImpersonationGuard } from 'auth/hooks/useImpersonationGuard';

type CardsTableProps = TableComponentParams<Tarjeta> & {
  onChangeAction?: (nroCuenta: number, card: Tarjeta, actionType: 'change') => void;
  onDisassociateAction?: (
    nroCuenta: number,
    card: Tarjeta,
    actionType: 'disassociate',
  ) => void;
  onAssociateAction?: (card: Tarjeta) => void;
  buttons?: boolean;
};

export const CardsTable = ({
  tableContent,
  onChangeAction,
  onDisassociateAction,
  onAssociateAction,
  buttons = true,
  placeholderRows,
}: CardsTableProps) => {
  const { guardWriteAction } = useImpersonationGuard();
  return (
    <Table
      thead={
        <tr>
          <th>Número de Tarjeta</th>
          <th>Denominación</th>
          <th>Cuenta</th>
          <th>Centro costo asociado</th>
          {buttons !== false && <th style={{ width: '1%' }} className="text-nowrap"></th>}
        </tr>
      }
      tbody={
        <>
          {tableContent?.map((card) => (
            <tr key={card.id}>
              <td>{card.numero}</td>
              <td>{card.denominacion}</td>
              <td>{card.numeroCuenta}</td>
              <td>{card.centroCostoAsociado ?? ' '}</td>
              {buttons !== false && (
                <td style={{ width: '1%' }} className="text-nowrap">
                  {card.centroCostoAsociado ? (
                    <>
                      <Tooltip text="Cambiar centro de Costos" position="left">
                        <Button
                          className="list-button"
                          color="inverted"
                          variant="ghost"
                          icon="SortHorizontalIcon"
                          size="small"
                          onClick={() =>
                            onChangeAction?.(card.numeroCuenta, card, 'change')
                          }
                        />
                      </Tooltip>
                      <Tooltip text="Desasociar Tarjeta" position="left">
                        <Button
                          type="button"
                          color="destructive"
                          icon="ErrorIcon"
                          size="small"
                          onClick={() =>
                            guardWriteAction(() =>
                              onDisassociateAction?.(
                                card.numeroCuenta,
                                card,
                                'disassociate',
                              ),
                            )
                          }
                        />
                      </Tooltip>
                    </>
                  ) : (
                    <Tooltip text="Asociar a centro de costos" position="left">
                      <Button
                        className="bg-secondary"
                        color="inverted"
                        variant="ghost"
                        icon="ChainIcon"
                        size="small"
                        onClick={() => onAssociateAction?.(card)}
                      />
                    </Tooltip>
                  )}
                </td>
              )}
            </tr>
          )) || <TablePlaceholder cols={buttons ? 5 : 4} rows={placeholderRows || 5} />}
        </>
      }
    />
  );
};
